/*define(function (require) {*/
import GoogleMapsApi from "../../GoogleMapsApi";
require("@modules/tools/ko.bootstrapSelect");
require("@modules/tools/ko.bootstrapSelect.typeahead");
var ko = require("knockout");
var $ = require("jquery");
require("@modules/tools/ko.bootstrap-select");
var FacilitySearchViewModel = require("@modules/tools/facility-search/facilitySearchViewModel");
require("@modules/tools/ko.dpOpenClose");
// Google Maps
var gApiKey = window.scan.googleMapsApiKey !== undefined ? window.scan.googleMapsApiKey : "";
var gmapApi = new GoogleMapsApi(gApiKey);
var gtmDataLayerPush = function (parameters, defaultParameters) {
    var dataLayer = window.dataLayer || [];
    var url = window.location.href.replace(/^.*\/\/[^\/]+/, "").split("?")[0];
    var jsonObject = {
        event: "gaPageview",
        eventCategory: "Pageview",
        eventAction: url,
        eventLabel: "Ancillary Search"
    };

    if (parameters.zipOrAddress && parameters.zipOrAddress !== defaultParameters["zipOrAddress"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-ancillary",
            eventAction: "Address",
            eventLabel: parameters.zipOrAddress
        });
        jsonObject.ancillaryAddress = parameters.zipOrAddress;
    }

    if (parameters.year && parameters.year !== defaultParameters["year"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-ancillary",
            eventAction: "Year",
            eventLabel: parameters.year
        });
        jsonObject.ancillaryYear = parameters.year;
    }

    if (parameters.radius && parameters.radius !== defaultParameters["radius"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-ancillary",
            eventAction: "MilesFromAddress",
            eventLabel: parameters.radius + " Miles"
        });
        jsonObject.ancillaryRadius = parameters.radius;
    }

    if (parameters.name && parameters.name !== defaultParameters["name"]) {
        dataLayer.push({
            event: "gaEvent",
            eventCategory: "Lookup-ancillary",
            eventAction: "AncillaryNameId",
            eventLabel: parameters.name
        });
        jsonObject.ancillaryNameId = parameters.name;
    }

    dataLayer.push(jsonObject);
};
$("#facility-search")
    .find(".google-address-lookup")
    .keydown(function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });
if ($("#facility-search").length > 0) {
    ko.applyBindings(new FacilitySearchViewModel(gtmDataLayerPush, gmapApi));
    $(".hide-load").removeClass("hide-load");
    $(".tool-load").removeClass("tool-load");
}
/*});*/
